import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;
const baseURLci = process.env.CI_APPS;

export default {
    async getDocuments({ type, page, clientId }) {
        const res = await Axios.get(
            `${baseURL}record/client-document/${clientId}`,
            {
                params: {
                    type,
                    page
                }
            }
        );

        return res.data.response;
    },
    async getCertificates({ type, page, clientId }) {
        const res = await Axios.get(
            `${baseURL}record/certificate/${clientId}/client`,
            {
                params: {
                    type,
                    page
                }
            }
        );

        return res.data.response;
    },
    async getWebforms(params) {
        const res = await Axios.get(`${baseURL}actor/webform`, {
            params: params
        });
        if (res && res.data) {
            return res.data.response;
        } else {
            return null;
        }
    },
    async getLetterEncodedId(documentId) {
        // objective: to get encoded Id
        const res = await Axios.get(`${baseURLci}client/letter/edit_content`, {
            params: {
                id: documentId
            }
        });

        return res.data.id;
    },
    async deleteDocument(type, id) {
        if (type === "letter") {
            await Axios.get(`${baseURLci}client/letter/remove`, {
                params: {
                    id: id
                }
            });
        } else if (type === "attachment") {
            await Axios.delete(`${baseURL}record/attachment/${id}`, {
                params: {
                    id: id
                }
            });
        }
    },
    async getLetterTemplate() {
        const res = await Axios.get(`${baseURL}account/template/letter`);
        return res.data.response.resources;
    },
    async getAuthor() {
        const res = await Axios.get(`${baseURL}actor/staff`, {
            params: {
                getAll: 1
            }
        });

        return res.data.response.resources;
    },
    async getProvider() {
        const res = await Axios.get(`${baseURL}actor/staff/business/providers`);

        if (res.data.response && res.data.response.resource) {
            return res.data.response.resource.data || [];
        }

        return [];
    },
    async getPatient(clientId) {
        const res = await Axios.get(
            `${baseURL}actor/client/${clientId}/patient`,
            {
                params: {
                    status: 1,
                    patient_actors: true
                }
            }
        );

        if (res.data.response) {
            return res.data.response.resources || [];
        }

        return [];
    },
    async getPatientMedicalNote(patientId) {
        const res = await Axios.get(
            `${baseURL}record/medical-note/${patientId}`
        );

        if (res.data.response) {
            return res.data.response.resources || [];
        }

        return [];
    },
    async saveNewLetter({
        pid,
        cid,
        sid,
        template,
        recipient_id,
        title,
        date,
        vet_id
    }) {
        const data = {};
        data.patient_id = pid;
        data.client_id = cid;
        data.soap_id = sid;
        data.template_id = template;
        data.recipient_id = recipient_id;
        data.title = title;
        data.date = date;
        data.vet_id = vet_id;

        const res = await Axios.post(`${baseURL}patient/letters`, data);
        if (res.data.response) {
            return res.data.response;
        }
        return null;
    },
    async searchClientContact({ query, field }) {
        return await Axios.get(`${baseURL}actor/client-contact-search`, {
            params: {
                query: query,
                field: field
            }
        });
    },
    async getPDFLetterURI(documentId) {
        const res = await Axios.get(
            `${baseURL}patient/print-letter/${documentId}`
        );

        if (res.data.response.code !== 200) {
            return null;
        }

        return res.data.response.resources.uri;
    },
    async getEmailDefaultLetter() {
        const id = 11; // letter
        const res = await Axios.get(`${baseURL}account/email-default/${id}`);

        if (res.data.response) {
            return res.data.response.resources || {};
        } else {
            return {}; // return object instead of null or undefined
        }
    },
    async getEmailTemplate({
        clientId,
        businessId,
        patientId = [],
        skipVariableReplacement = false
    }) {
        const emailType = 11; // letter

        const formData = new FormData();
        formData.append("params[0][email_type]", emailType);
        formData.append("params[0][business_id]", businessId);
        formData.append("params[0][client_id]", clientId);
        formData.append(
            "params[0][skip_variable_replacement]",
            skipVariableReplacement
        );

        for (const patient of patientId) {
            formData.append("params[0][patient_id][]", patient);
        }

        const res = await Axios.post(
            `${baseURLci}common/appointment/getEmailTemplate`,
            formData
        );

        if (
            res.data.response &&
            res.data.response[0] &&
            res.data.response[0].email_template
        ) {
            return res.data.response[0].email_template;
        } else {
            return {};
        }
    },
    async getClientContact(type) {
        const res = await Axios.get(`${baseURL}actor/all-client-contact`, {
            params: {
                field: type
            }
        });

        if (res.data.response && res.data.response.resource) {
            return res.data.response.resource;
        }

        return [];
    },
    async sendEmail({
        to = [],
        letterId,
        firstname,
        lastname,
        subject,
        message,
        timestamp
    }) {
        const formObj = {};
        formObj.id = letterId;
        formObj.timestamp = timestamp;
        formObj.email_type = 11;
        formObj.first_name = firstname;
        formObj.last_name = lastname;
        formObj.subject = subject;
        formObj.message = message;
        formObj.to = to;

        const res = await Axios.post(
            `${baseURL}patient/email-letter/${letterId}`,
            formObj
        );

        if (res.data.response.code === 200) {
            return true; // success
        }

        return false; // failed
    },
    emailAttachment(params) {
        return Axios.post(
            `${baseURL}record/send-email-attachment`,
            params
        ).then(response => response.data.response);
    },
    getTabCounts(clientId) {
        return Axios.get(
            `${baseURL}record/client-document/${clientId}/tab-count`
        ).then(response => response.data.response);
    }
};
